import { render, staticRenderFns } from "./MealCategories.vue?vue&type=template&id=3eccc43e"
import script from "./MealCategories.vue?vue&type=script&lang=js"
export * from "./MealCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports